// Event bus for map-related events
export class MapEventBus {
  private static instance: MapEventBus;
  private events: { [key: string]: Array<(...args: any[]) => void> } = {};

  private constructor() {}

  static getInstance(): MapEventBus {
    if (!MapEventBus.instance) {
      MapEventBus.instance = new MapEventBus();
    }
    return MapEventBus.instance;
  }

  on(event: string, callback: (...args: any[]) => void): void {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(callback);
  }

  off(event: string, callback: (...args: any[]) => void): void {
    if (this.events[event]) {
      this.events[event] = this.events[event].filter(cb => cb !== callback);
    }
  }

  emit(event: string, ...args: any[]): void {
    if (this.events[event]) {
      this.events[event].forEach(callback => {
        callback(...args);
      });
    }
  }
}

export const mapEventBus = MapEventBus.getInstance();